import Collections from '../utils/collections';

import BaseDocument from './BaseDocument';

/**
 * class representing the workout request data
 *
 * @class WorkoutRequest
 * @extends BaseDocument
 */
class WorkoutRequest extends BaseDocument {
  constructor(id, opts) {
    super(`${Collections.WORKOUT_REQUEST}/${id}`, opts);
  }

  /**
   * Get the workout request id
   * @return {string}
   */
  get workoutRequestId() {
    return this.data.workoutRequestId;
  }

  /**
   * Get the workout of the request
   * @return {string}
   */
  get workoutId() {
    return this.data.workoutId;
  }

  /**
   * Update the workout request
   * @param {string} workoutRequestId - The id of the workout request
   * @param {Object} data - The data to update the workout request with
   * @return {Promise<void>}
   */
  static async updateDoc(workoutRequestId, data) {
    const workoutRequestDoc = new WorkoutRequest(workoutRequestId);
    await workoutRequestDoc.init();
    return workoutRequestDoc.update(data);
  }
}

export default WorkoutRequest;
